<template>
  <div class="reward_detail" :class="{'isiOSX1':isiOSX}">
    <van-nav-bar
      title="奖励明细"
      :fixed="true"
      left-arrow
      @click-left="reBack"
      :class="{'isiOSX':isiOSX}"
    />
    <div class="box">
      <p class="tip">明细详情请去会员积分明细中查看</p>
      <div class="search">
        <div class="left" @click="showDatePopup">{{selectData}} <span></span></div>
      </div>
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh" v-if="list">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="别拉了，小巴也是有底线的"
          @load="onLoad"
        >
          <van-row class="reward_list">
            <van-col span="24">
              <div class="details" v-for="(item, index) in list" :key="index">
                <p class="data">{{item.month_day}}</p>
                <div class="item">
                  <div class="left">{{item.remark}}</div>
                  <div class="right">
                    <span class="integral">+{{item.reward_credits}}</span>
                    <span class="time">{{item.hour_minute}}</span>
                  </div>
                </div>
              </div>
            </van-col>
          </van-row>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-popup v-model="showdate" position="bottom">
      <van-datetime-picker
        @cancel="cancel"
        @confirm="confirm($event,'selectData')"
        :formatter="formatter"
        v-model="currentDate"
        type="year-month"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
export default {
  data() {
    return {
      isiOSX: false,
      showdate: false,
      selectData: '',
      currentDate: new Date(),
      parmYearMonth: '',
      minDate: new Date(2021, 0, 1),
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 0,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    this.$api.setToken(this.$route.query.token);
    var year = this.currentDate.getFullYear();
    var month = this.currentDate.getMonth() + 1;
    this.selectData = year + "年" + month + "月";
    this.parmYearMonth = year + (month < 10 ? "0" + month : "" +month);
    // this.getReward();
  },
  methods: {
    reBack() {
      this.$router.go(-1);
    },
    showDatePopup() {
      this.showdate = true;
    },
    formatter(type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`;
      }
      return value;
    },
    confirm(value, item) {
      this.showdate = false;
      var year = value.getFullYear();
      var month = value.getMonth() + 1;
      this.selectData = year + "年" + month + "月";
      this.parmYearMonth = year + (month < 10 ? "0" + month : "" + month);
      this.onRefresh();
    },
    cancel() {
      this.showdate = false;
    },
    getReward() {
      this.$api
        .post("/member-relation/member/group/manager/reward/record/list", {
          year_month: this.parmYearMonth,
          type: this.$route.query.type, //群成员类型 1群主 2群成员
          page: this.page,
        })
        .then((res) => {
          this.allList = res.total;
          if (res.list.length > 0) {
            for(let i in res.list) {
              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        });
    },
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getReward();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getReward();
    },
  }
};
</script>
<style>
  html {
    font-size: calc(var(--sizeScale2) * 10px);
  }
</style>
<style lang="less" scoped>
.reward_detail {
  min-height: 100%;
  box-sizing: border-box;
  background: #F5F6F7;
  padding-top: 72px;
  /deep/.van-nav-bar {
    height: 44px;
    line-height: 44px;
    padding-top: 28px;
    border: none;
    box-shadow: none;
    background: #fff;
    overflow: hidden;
    .van-nav-bar__title {
      color: #333;
      font-size: 1.8rem;
      font-weight: 400;
    }
    .van-nav-bar__text {
      color: #333;
      font-size: 1.6rem;
      font-weight: 400;
      padding: 0 1.2rem;
    }
    .van-icon {
      color: #333;
    }
  }
  .isiOSX {
    padding-top: 44px;
  }
  .box {
    padding: 1.5rem 1.2rem 0;
    .tip {
      color: #999;
      font-size: 1.4rem;
      height: 2.3rem;
      line-height: 2.3rem;
    }
    .search {
      height: 3.2rem;
      line-height: 3.2rem;
      margin: 0.3rem 0 0.6rem;
      .left {
        width: 9.9rem;
        color: #333;
        font-size: 1.4rem;
        position: relative;
        float: left;
        span {
          width: 0;
          height: 0;
          border-left: 4px solid transparent;
          border-right: 4px solid transparent;
          border-top: 4px solid #333;
          position: absolute;
          right: 1.5rem;
          top: 1.5rem;
        }
      }
    }
    .reward_list {
      width: 100%;
      .details {
        .data {
          height: 2.3rem;
          line-height: 2.3rem;
          margin-top: 0.9rem;
        }
        .item {
          color: #333;
          height: 8.3rem;
          border-radius: 0.8rem;
          background: #fff;
          padding: 1.4rem 1.8rem;
          margin-top: 0.9rem;
          box-sizing: border-box;
          position: relative;
          .left {
            font-size: 1.5rem;
            height: 2.4rem;
            margin-top: 1.5rem;
            float: left;
          }
          .right {
            float: right;
            text-align: right;
            .integral {
              font-size: 1.6rem;
              height: 2.6rem;
              line-height: 2.6rem;
              margin-bottom: 0.5rem;
              display: block;
            }
            .time {
              color: #999;
              font-size: 1.4rem;
              line-height: 2.3rem;
              display: block;
            }
          }
        }
      }
    }
  }
}
.isiOSX1 {
  padding-top: 88px;
}
</style>


